import React from 'react';
import {format} from 'date-fns';

const LegHeader = props => {
    const { time, heading } = props;
    return (
        <div className="otp-trip-leg-header">
            <div className="otp-trip-time">{format(time, 'h:mm a')}</div>
            <div className="otp-trip-divider"></div>
            <div className="otp-trip-text">{heading}</div>
        </div>
    );
};

export default LegHeader;